import { AssistenciaSocial as AssistenciaSocialPessoa } from "../../Pessoa/Setor/AssistenciaSocial";

export const AssistenciaSocial = ({ pessoa, setPessoa }) => (
  <>
    <AssistenciaSocialPessoa pessoa={pessoa} setPessoa={setPessoa} />
  </>
);
